import Cookies from 'js-cookie';

export const getCookie = (name) => Cookies.get(name);

export const setCookie = (
  name,
  value,
  expires,
  callback = () => {
    /* empty */
  },
) => {
  Cookies.set(name, value, { expires });
  callback();
};
